import { Button, styled } from "@mui/material";

const MenuButton = styled(Button, {
	shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
	minWidth: "auto",
	padding: theme.spacing(0.5),
	backgroundColor: isActive ? theme.palette.action.selected : "transparent",
	color: theme.palette.text.primary,
	className: `tiptap-toolbar-button${isActive ? " is-active" : ""}`,
}));

export default MenuButton;
